import { NavLink } from 'react-router-dom'
import { css, styled } from 'styled-components'

import { onSurfaceDim, surfaceBrightHover } from 'core/styles'

export const Title = styled.div`
  margin-bottom: 16px;
  font-size: 26px;
  font-weight: 700;
`

export const ItemCSS = css<{ $depth?: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  border-radius: 8px;
  cursor: pointer;
  padding: 8px 16px;
  padding-left: calc(16px + ${({ $depth }) => ($depth && $depth > 0 ? $depth * 24 : 0)}px);
  line-height: 28px;
  font-size: 16px;
  font-weight: 500;

  &:hover {
    text-decoration-color: ${onSurfaceDim};
  }
`

export const Item = styled.div<{ $depth?: number }>`
  ${ItemCSS}
`

export const Link = styled(NavLink)<{ $depth?: number }>`
  ${ItemCSS}

  &.active {
    background-color: ${surfaceBrightHover};
    font-weight: 700;
  }
`

export const Label = styled.span`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`

export const NavigationWrapper = styled.div<{ $variant?: 'default' | 'compact' }>`
  ${({ $variant }) =>
    $variant === 'compact' &&
    css`
      ${Title} {
        margin-bottom: 12px;
        font-size: 20px;
      }

      ${ItemCSS} {
        padding: 6px 12px;
        line-height: 24px;
        font-size: 14px;
      }
    `}
`
